import {
  Grid,
  Typography,
  CardContent,
  CardHeader,
  useTheme,
  Card,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {
  JobBody,
  JobTitle,
  StyledCard,
  StyledCardHeader,
} from "../../../styles/OurJobsStyles";
import {
  ITMicrosoftLicences,
  ITGoogleLicences,
} from "../../../data/TabsContent";
import { motion } from "framer-motion";

const IT = () => {
  return (
    <>
      <Box component={motion.div}>
        <JobTitle sx={{ textTransform: "none" }}>Solutions Odoo</JobTitle>
        <Box mb={2}>
          <JobBody align="center">
            Développement d'un ERP adapté aux besoins de l'entreprise (Pour les
            PME)
          </JobBody>
        </Box>
      </Box>
    </>
  );
};

export default IT;

const CardItem = ({ item, open, setOpen }) => {
  const theme = useTheme();

  return (
    <StyledCard initial="hidden" animate="shown">
      <StyledCardHeader title={item.name} />
    </StyledCard>
  );
};
